const SDK_VERSION = '8.21.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
